import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./SchoolAcademicPage.css";
import SchoolInnerPageBanner from "../../components/SchoolInnerPageBanner";
import QuestionBank from "../../components/AcademicQuestionBank";
import TechnoAEP from "../../components/AcademicTechnoAEP";

const containerStyle = {
  maxWidth: "1200px",
  margin: "0 auto",
};

const SchoolAcademicPage = () => {
  const location = useLocation();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    const sectionId = location.state?.scrollTo;
    if (!sectionId) return;

    const timer = setTimeout(() => {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 150);

    return () => clearTimeout(timer);
  }, [location.key]);

  useEffect(() => {
    scrollToTop();
  }, []);

  return (
    <>
      <div className="academics-page">
        <SchoolInnerPageBanner />

        {/* Question Bank Section */}
        <QuestionBank />

        {/* Techno AEP Section */}
        <TechnoAEP />

      </div>

      {/* 🔹 SCHOOL FOOTER */}
    </>
  );
};

export default SchoolAcademicPage;